import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id", "checked", "name"]

import { PropType } from "vue";

import { useMetadataStore } from "@/stores/metadata.store";

import { MetadataAllowedValues } from "@/models/content-templates.model";
import {
  MetadataAllocatedValuesItem,
  MetadataInstance
} from "@/models/product-section.model";

import { isMetadataValueChecked } from "@/utils/content-metadata-helpers";


export default /*#__PURE__*/_defineComponent({
  __name: 'MultipleOption',
  props: {
  instances: {
    required: true,
    type: Array as PropType<MetadataInstance[]>
  },
  value: {
    required: true,
    type: Object as PropType<MetadataAllowedValues>
  },
  currentInstance: {
    required: true,
    type: Object as PropType<MetadataInstance>
  },
  productId: {
    required: true,
    type: Number
  }
},
  setup(__props) {

const metadataStore = useMetadataStore();

const props = __props;
const getMetadataMultipleAllocatedValueId = (): number | undefined => {
  if (
    props.currentInstance.metadata_definition.metadata_allocated_values.length >
    0
  ) {
    const currentValue =
      props.currentInstance.metadata_definition.metadata_allocated_values.find(
        (e: MetadataAllocatedValuesItem) => {
          return e.metadata_allowed_value_id === props.value.id;
        }
      );
    return currentValue ? currentValue.id : undefined;
  }
  return undefined;
};
const toggleMetadataAllocatedValue = async (event: {
  currentTarget: HTMLInputElement;
}) => {
  if (!event.currentTarget.checked) {
    const id = getMetadataMultipleAllocatedValueId();
    if (id) {
      const payload = {
        id,
        productId: props.productId
      };
      await metadataStore.deleteMetadataAllocatedValues(payload);
    }
  } else {
    const payload = {
      value: {
        metadata_allowed_value_id: props.value.id,
        metadata_instance_id: props.currentInstance.id
      },
      productId: props.productId
    };
    await metadataStore.createMetadataAllocatedValues(payload);
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("input", {
    id: __props.value.id,
    checked: _unref(isMetadataValueChecked)(__props.currentInstance, __props.value.id),
    name: __props.currentInstance.metadata_definition.name,
    type: "checkbox",
    onChange: _cache[0] || (_cache[0] = ($event: any) => (toggleMetadataAllocatedValue($event)))
  }, null, 40, _hoisted_1))
}
}

})